import { ReusablePaymentMethodBase } from './reusable-payment-method-base';

export interface DirectDebit extends ReusablePaymentMethodBase {
  type: 'DIRECT_DEBIT';
  accountOwner: string;
  iban: string;
  bank: string | null;
  bic: string | null;
}
